import { useContext } from "react";
import type { Branding } from "./branding-context.ts";
import { BrandingContext } from "./branding-context.ts";

export const useBranding = (): Branding => useContext(BrandingContext);
